import React, { useState } from 'react'
import { PayOut } from '.'
import { AdvancePayout } from './AdvancePayout'

export const PayoutTab = () => {
    const [adpTab,setadpTab] = useState(false)
  return (
    <>
    {
        adpTab ? <AdvancePayout setadpTab={setadpTab}/> : <PayOut setadpTab={setadpTab}/>
    }
    </>
  )
}
